'use strict';

const notImplementedError = Error('Not implemented');

export default class iUserService{
  getAllUsers() {
    throw new notImplementedError;
  }
  getUserById() {
    throw new notImplementedError;
  }
  addUser() {
    throw new notImplementedError;
  }
  updateUser() {
    throw new notImplementedError;
  }
}
